export default {
  dSummaries: [],
  salesBySites: [],
}
